"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POST_TYPES = void 0;
var POST_TYPES = exports.POST_TYPES = {
  STANDARD: 'Standard',
  FEATURED: 'Featured',
  PREMIERE: 'Premiere',
  SPONSORED: 'Sponsored',
  SUBMITTED: 'Submitted',
  PROMOTED: 'Promoted'
};
Object.freeze(POST_TYPES);